const changePanoramicStep = (state, action) => {
  if (state === undefined) {
    return 1;
  }

  switch (action.type) {
    case 'CHANGE_PANORAMIC_STEP':
      return action.payload;
    // A tab switch from the billing step opens the payment screen of the new
    // tab; the key-change effect that also resets it runs only while mounted.
    case 'RESET_TAB_STATE':
      return 1;
    default:
      return state.panoramicBillingPageStep;
  }
};

export { changePanoramicStep };
